/**
 * データソートできるテーブル
 **/

$(document).ready( function() {
  'use strict';

    // tableショートコードで作成されたset-default-orderの内容をテーブルに反映する
    let init_setting = () => {
        let element = document.getElementsByClassName("set-default-order");
        if (element.length > 0) {
            return getOrder();
        } else {
            return false;
        }
    }

    let getOrder = () => {
        let result = [];
        let div = document.getElementsByTagName('div');
        for(let i = 0; i < div.length; ++i){
            if(div[i].classList.contains('set-default-order') === true){
                let data = div[i].dataset.defaultOrder;
                result.push(data); 
            }      
        }
        return result;
    }

    let div_orders = init_setting();

    /**
     * テーブルへ並び替えを適用
     **/
    function applyDataTable( content, index ) {

        let order = div_orders[index] || false;

        var sort_options = {
            // 件数切替機能 無効
            lengthChange: false,
            // 検索機能 無効
            searching: false,
            // ソート機能 無効
            ordering: true,
            // 情報表示 無効
            info: false,
            // ページング機能 無効
            paging: false,
            // 自動幅調整 無効
            bAutoWidth: false,
        };

        if($(".locale-compare-table").length || $(".table-sort").length){
            sort_options['columnDefs'] = [{ targets: '_all', type: 'locale-compare' }]
        }

        if(order !== false){
            var orders = order.split(':');
            sort_options.order = [ [ parseInt(orders[0])-1,orders[1] ] ]; 
        } else {
            var default_order = $(content).data('default-order');
            if ( default_order ) { 
                var orders = default_order.split(':');
                sort_options.order = [ [ parseInt(orders[0])-1,orders[1] ] ]; 
            }
        }

        //console.log(sort_options);
        $(content).DataTable(sort_options);
        console.log('init datatable', sort_options);
    }

  //データテーブルを適用する
    moko.initDataTables = function( content ) { 
        content.find('.table-sort table,table.table-datatable').each( function(index) {
            //console.log('init datatables begin');
            applyDataTable( this, index );
        });
    /*
    content.find('.table-sort table').each( function() {
      console.log('init datatables begin');
      applyDataTable( this );
    });
    content.find('table.table-datatable').each( function() {
      console.log('init datatables begin');
      applyDataTable( this );
    });
    */
    };
  

    //初期化
    document.addEventListener("DOMContentLoaded", ()=> moko.initDataTables($(document)));
});

/**
 * 50音順にソート関数を追加
 **/
$.extend( $.fn.dataTableExt.oSort, {
  'locale-compare-asc': function ( a, b ) {
    a = a.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g, '');
    b = b.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g, '');
    return a.localeCompare(b, 'ja', { numeric: 'true' });
  },
  'locale-compare-desc': function ( a, b ) {
    a = a.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g, '');
    b = b.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g, '');
    return b.localeCompare(a, 'ja', { numeric: 'true' })
  }
});


